import React, { useState } from "react";
import "./VeiculoseciaVehicleCard.scss";
import Slider from "react-slick";
import {
  Card,
  CardContent,
  Box,
  Typography,
  CardActions,
  Button,
} from "@mui/material";
import { formatValor, formatKm } from "../../../utils/webConstants";
import { MdCalendarToday, MdOutlineFormatPaint, MdSpeed } from "react-icons/md";
import { GiGearStickPattern } from "react-icons/gi";
import { BsTruckFlatbed } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { logClickView } from "../../../services/logService";

function VeiculoseciaVehicleCard({ vehicle }) {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  // Configurações do Slider (carrossel)
  const sliderSettings = {
    infinite: false, // Carrossel infinito
    speed: 500, // Velocidade da transição
    slidesToShow: 1, // Mostrar 1 slide por vez
    slidesToScroll: 1, // Rolar 1 slide por vez
    autoplay: false, // Não iniciar automaticamente
    // autoplaySpeed: 3000, // Se autoplay for true, tempo entre transições
    arrows: true, // Mostrar setas de navegação (próximo/anterior)
    // fade: true,       // Opcional: Transição com fade em vez de slide
    // Adicionar a função beforeChange para atualizar o estado do slide atual
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
  };

  // Obter o número total de imagens
  const totalImages = vehicle.imagens ? vehicle.imagens.length : 0;

  const handleNavigateDetails = async (veiculoId) => {
    navigate(`/anuncio/${veiculoId}`);
    await logClickView(veiculoId);
  };

  return (
    <Card
      className="vehicle__card"
      sx={{
        maxWidth: 345,
        margin: "auto",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
      }}
    >
      <Box
        sx={{ width: "100%", height: 190, position: "relative" }}
        className="item"
      >
        {" "}
        {/* Contêiner para o Slider */}
        {totalImages > 0 && ( // Mostra o indicador apenas se houver imagens
          <Box
            sx={{
              position: "absolute",
              bottom: 10,
              left: 10,
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Fundo preto semitransparente
              color: "white",
              padding: "4px 8px",
              borderRadius: "8px",
              zIndex: 10, // Garante que fique acima da imagem
              fontSize: "10px",
            }}
          >
            {`${currentSlide + 1}/${totalImages}`}{" "}
            {/* currentSlide é 0-based */}
          </Box>
        )}
        {vehicle.imagens && vehicle.imagens.length > 0 ? (
          <Slider {...sliderSettings}>
            {" "}
            {/* Use o componente Slider */}
            {vehicle.imagens.map((imagem, index) => (
              <div key={imagem.id || index}>
                {" "}
                {/* Cada item do slider precisa ser envolvido em uma div */}
                <Box
                  component="img"
                  src={imagem.ftp_url}
                  alt={vehicle.modelo}
                  sx={{
                    height: 190, // Altura fixa para as imagens
                    width: "100%",
                    objectFit: "cover", // Garante que a imagem preencha o espaço
                    display: "block", // Garante que a imagem se comporte como um bloco para ocupar a largura total
                  }}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "/default.jpg";
                  }}
                  onClick={() => handleNavigateDetails(vehicle.id)}
                />
              </div>
            ))}
          </Slider>
        ) : (
          // Imagem padrão quando não há imagens
          <Box
            component="img"
            src="https://placehold.co/345x140?text=Sem+Imagem"
            alt="Sem Imagem"
            sx={{
              height: 140,
              width: "100%",
              objectFit: "contain",
            }}
          />
        )}
      </Box>

      <CardContent
        sx={{
          flexGrow: 1,
          gap: "8px",
          display: "flex",
          flexDirection: "column",
        }}
        onClick={() => handleNavigateDetails(vehicle.id)}
      >
        {vehicle.oferta && (
          <div className="oferta">
            <p className="m-0">Oferta Destaque</p>
          </div>
        )}
        <Typography
          className="mb-0 card__title"
          gutterBottom
          variant="h6"
          component="div"
        >
          {vehicle.categoria.id === 1 || vehicle.categoria.id === 3 ? (
            <>
              {vehicle.marca.nome} {vehicle.modelo}
            </>
          ) : (
            vehicle.categoria.id === 2 && (
              <>
                {vehicle.tipo} {vehicle.marca.nome}
              </>
            )
          )}
        </Typography>
        <div className="d-flex flex-wrap gap-2">
          <div className="d-flex align-items-center gap-1">
            <MdCalendarToday />
            <Typography variant="body2" color="text.secondary">
              {vehicle.ano_fabricacao}/{vehicle.ano_modelo}
            </Typography>
          </div>

          <div className="d-flex align-items-center gap-1">
            {vehicle.categoria.id === 1 || vehicle.categoria.id === 3 ? (
              <>
                <MdSpeed />
                <Typography variant="body2" color="text.secondary">
                  {formatKm(vehicle.km)}
                </Typography>
              </>
            ) : (
              vehicle.categoria.id === 2 && ( // Use && aqui
                <>
                  <BsTruckFlatbed />
                  <Typography variant="body2" color="text.secondary">
                    {vehicle.modelo}
                  </Typography>
                </>
              )
            )}
          </div>
        </div>

        <div className="d-flex flex-wrap gap-2">
          <div className="d-flex align-items-center gap-1">
            {vehicle.categoria.id === 1 || vehicle.categoria.id === 3 ? (
              <>
                <GiGearStickPattern />
                <Typography variant="body2" color="text.secondary">
                  {vehicle.cambio.toLowerCase()}
                </Typography>
              </>
            ) : (
              vehicle.categoria.id === 2 && ( // Use && aqui
                <>
                  <MdOutlineFormatPaint />
                  <Typography variant="body2" color="text.secondary">
                    {vehicle.cor.toLowerCase()}
                  </Typography>
                </>
              )
            )}
          </div>
          {vehicle.categoria.id === 1 && (
            <div className="d-flex align-items-center gap-1">
              <BsTruckFlatbed />
              <Typography variant="body2" color="text.secondary">
                {vehicle.tracao.toLowerCase()}
              </Typography>
            </div>
          )}
        </div>

        <Typography
          className="m-0 mt-auto card__price"
          variant="h5"
          color="primary"
          sx={{ mt: 1 }}
        >
          {formatValor(vehicle.valor)}
        </Typography>
      </CardContent>
      <CardActions sx={{ mt: "auto" }}>
        {" "}
        {/* Adiciona margem superior automática para empurrar para o final */}
        <Button
          variant="contained"
          sx={{
            width: "100%",
            backgroundColor: "#292929",
            color: "#FFF",
            "&:hover": {
              backgroundColor: "#404040",
            },
          }}
          onClick={() => handleNavigateDetails(vehicle.id)}
        >
          Ver Detalhes
        </Button>
      </CardActions>
    </Card>
  );
}

export default VeiculoseciaVehicleCard;
